Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "WidgetRoot1717124616",
  {"spinner":"WidgetRoot1717124616--spinner","root":"WidgetRoot1717124616--root"},
  "",
  11,
  "WidgetRoot1717124616"
);

